import { Stat, StatHelpText, Flex, Text, Box, Badge } from "@chakra-ui/react";

const StatDiscription = ({
    description,
    number,
    helpNumber,
    helpText,
    helpColor,
    ml,
    mt,
    stat,
    h,
}: {
    description?: string;
    number?: number;
    helpNumber?: number | string;
    helpText?: string;
    helpColor?: string;
    ml?: string;
    mt?: string;
    stat?: any;
    h?: string;
}) => {
    return (
        <Stat flex="1" ml={ml}>
            <Flex w="100%" alignItems="center" h={h}>
                <Box flex="1" mt={mt}>
                    <Text fontSize="25px" fontWeight="600" color="black">
                        {stat}
                    </Text>
                    <Text
                        fontWeight="500"
                        fontSize="17px"
                        mb="0px"
                        mt="0px"
                        color={"black"}
                    >
                        {description}
                    </Text>
                    <StatHelpText>
                        <Text display="inline" color={helpColor}>
                            {helpNumber}
                        </Text>{" "}
                        {helpText}
                    </StatHelpText>
                </Box>
            </Flex>

            <Flex>
                <Box
                    position={"absolute"}
                    top={"0"}
                    right={"0"}
                    mt={"10px"}
                    mr={"10px"}
                >
                    <Badge
                        background={
                            helpColor === "green" ? "#ECF9ED" : "#F9EDED"
                        }
                        color={helpColor}
                        fontSize={"12px"}
                        fontWeight={"600"}
                    >
                        {helpNumber}
                    </Badge>
                </Box>
            </Flex>
        </Stat>
    );
};

export default StatDiscription;
